var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHowItWorksBgTwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 704,
    viewBox: "0 0 1440 704",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_328_445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2516.26 727.97L1992.46 302.874C1901.72 229.233 1793.99 179.481 1679.09 158.156L1390.94 104.675C1242.17 77.0635 1115.65 -20.1824 1050.69 -156.842L524.615 -1263.68L608.742 -1347.8L1200.51 -102.753C1225.44 -50.3065 1259.83 -2.90876 1301.96 37.0605L1834.41 542.271L2411.8 250.034L2600.39 643.844L2516.26 727.97Z",
    fill: "url(#paint0_linear_328_445)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_328_445",
    x1: 1172.98,
    y1: 79.602,
    x2: 2089.68,
    y2: 445.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE5",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4060EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_328_445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 216,
    fill: "white",
    transform: "matrix(-1 0 0 -1 1440 216)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksBgTwo);
export default __webpack_public_path__ + "static/media/HowItWorksBgTwo.1efb2c62ae3fb431faa930ad4dc7cd14.svg";
export { ForwardRef as ReactComponent };